import React, { useContext, useEffect, useRef } from 'react';
import cx from 'classnames';

import { StoreContext } from 'store';
import { Button } from 'components/Button';
import { Text } from 'components/Text';
import { Icon } from 'components/Icons';

import './resultPage.scss';
import { trackEvent } from 'analytics/amplitude';

export const Fail: React.FC = () => {
  const { translation: t } = useContext(StoreContext);
  const pageOpened = useRef(false);
  const isPageInIframe = window.self !== window.top;

  useEffect(() => {
    if (pageOpened.current === false) {
      trackEvent('purchase_finished', { status: 'failed' });
      pageOpened.current = true;
    }
  }, []);

  const handleClick = () => {
    // Create a message to send
    const message = JSON.stringify({
      message: 'closeModal',
    });
    // Send the message to the parent window
    window.parent.postMessage(message, '*');
  };

  const renderButton = () => {
    if (isPageInIframe)
      return (
        <Button
          size="xl"
          Icon={Icon.MarketCart}
          withTriangle
          onClick={handleClick}
          hasMobileSize={true}
        >
          {t.market.resultPage.buttonText.toUpperCase()}
        </Button>
      );

    return (
      <a href={'https://market.tacticool.game'} rel="noreferrer">
        <Button size="xl" Icon={Icon.MarketCart} withTriangle hasMobileSize={true}>
          {t.market.resultPage.buttonText.toUpperCase()}
        </Button>
      </a>
    );
  };

  return (
    <div className="result-page">
      <div className="result-page__header">
        <Icon.Close
          className={cx('result-page__header-icon', 'result-page__header-icon-fail')}
        />
        <div className="result-page__header-text">
          <Text.HeaderL>{t.market.resultPage.fail.title}</Text.HeaderL>
          <Text.HeaderS>{t.market.resultPage.fail.subtitle}</Text.HeaderS>
        </div>
      </div>
      <div className="result-page__footer">
        {renderButton()}
        <img
          className="result-page__footer-image"
          src="/img/common/batya_fail.webp"
          alt="Succes"
        />
      </div>
    </div>
  );
};
